export default "__VITE_ASSET__CqsxMm2I__"